import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import application pages/components
import Start from "../pages/Start";
import Testclient from '../components/testclient/layout/Testclient';
import TestRun from '../components/testclient/layout/Testrun';
import TestReports from '../pages/TestReports';
import ReviewAnswersPage from '../pages/ReviewAnswersPage';
import E2EUserPage from '../pages/E2EUserPage';
import FormPage from '../pages/FormPage';
import { useAuth } from '../contexts/AuthContext';
import CreateUserPage from "../pages/CreateUserPage";
import ProtectedAdminRoute from '../components/ProtectedAdminRoute';
import ProtectedReviewerRoute from '../components/ProtectedReviewerRoute';
import ProtectedTesterRoute from '../components/ProtectedTesterRoute';
import ProtectedE2EUserRoute from '../components/ProtectedE2EUserRoute';
import ProtectedE2EReviewerRoute from '../components/ProtectedE2EReviewerRoute';
import SubmissionList from '../components/E2E/SubmissionList';
import SubmissionReview from '../components/E2E/SubmissionReview';
import MySubmissions from '../components/E2E/MySubmissions';
import ReviewerHome from '../pages/ReviewerHome';
import SubmissionEdit from '../components/E2E/SubmissionEdit';
import ClarifySubmission from '../components/E2E/ClarifySubmission';
import SubmissionDetails from '../components/E2E/SubmissionDetails';
import ReviewerSubmissionDetails from '../components/E2E/ReviewerSubmissionDetails';
import CreateOrganisationPage from "../pages/CreateOrganisationPage";
import OrganisationsPage from "../pages/OrganisationsPage";
import UsersPage from "../pages/UsersPage";
import DepartmentsPage from "../pages/DepartmentsPage";
import CreateServiceOrderPage from "../pages/CreateServiceOrderPage";
import ServiceOrdersAdminPage from "../pages/ServiceOrdersAdminPage";
import QuestionsAdminPage from "../pages/QuestionsAdminPage";
import ContractsAdminPage from "../pages/ContractsAdminPage";
import TkbAdminPage from "../pages/TkbAdminPage";
import ReviewerDecisionQueue from '../pages/ReviewerDecisionQueue';


// Logout component
function LogoutPage() {
    const { logout } = useAuth();

    React.useEffect(() => {
        logout();
    }, [logout]);

    return <div>Logging out...</div>;
}

/**
 * Main routing configuration for the application.
 * Maps each URL path to the corresponding page component.
 */
const AppRoutes = () => (
  <Routes>

    {/* Redirect root to /start - AuthContext will handle authentication */}
    <Route path="/" element={<Navigate to="/start" replace />} />

    <Route path="/start" element={<Start />} />
    <Route path="/testklient" element={
        <ProtectedTesterRoute>
            <Testclient />
        </ProtectedTesterRoute>
    } />
    <Route path="/testklient/:contractId" element={
        <ProtectedTesterRoute>
            <TestRun />
        </ProtectedTesterRoute>
    } />
    <Route path="/testrapporter" element={<TestReports />} />
    <Route path="/reviewer/jira-beslut" element={
        <ProtectedReviewerRoute>
            <ReviewerDecisionQueue />
        </ProtectedReviewerRoute>
    } />
    <Route path="/testrapporter/granska/:executionId" element={<ReviewAnswersPage />} />
    <Route path="/createserviceorder" element={
        <ProtectedAdminRoute>
            <CreateServiceOrderPage />
        </ProtectedAdminRoute>
    } />
    <Route path="/serviceorders" element={
        <ProtectedAdminRoute>
            <ServiceOrdersAdminPage />
        </ProtectedAdminRoute>
    } />
    <Route path="/createuser" element={
        <ProtectedAdminRoute>
          <CreateUserPage />
        </ProtectedAdminRoute>
    } />
    <Route path="/createorganisation" element={
        <ProtectedAdminRoute>
            <CreateOrganisationPage/>
        </ProtectedAdminRoute>
    } />
    <Route path="/organisations" element={
        <ProtectedAdminRoute>
            <OrganisationsPage />
        </ProtectedAdminRoute>
    } />
    <Route path="/users" element={
        <ProtectedAdminRoute>
            <UsersPage />
        </ProtectedAdminRoute>
    } />
    <Route path="/departments" element={
        <ProtectedAdminRoute>
            <DepartmentsPage />
        </ProtectedAdminRoute>
    } />
    <Route path="/editquestions" element={
        <ProtectedAdminRoute>
            <QuestionsAdminPage />
        </ProtectedAdminRoute>
    } />
    <Route path="/editcontracts" element={
        <ProtectedAdminRoute>
            <ContractsAdminPage />
        </ProtectedAdminRoute>
    } />
    <Route path="/tkb-admin" element={
        <ProtectedAdminRoute>
            <TkbAdminPage />
        </ProtectedAdminRoute>
    } />

    <Route path="/logout" element={<LogoutPage />} />

    <Route path="/e2e/tester" element={
        <ProtectedE2EUserRoute>
          <E2EUserPage />
        </ProtectedE2EUserRoute>
    } />
    <Route path="/e2e/tester/forms/:formId" element={
      <ProtectedE2EUserRoute>
        <FormPage />
      </ProtectedE2EUserRoute>
    } />

    <Route path="/e2e/tester/submissions" element={
      <ProtectedE2EUserRoute>
        <MySubmissions />
      </ProtectedE2EUserRoute>
    } />

    <Route path="/e2e/submissions/:submissionId" element={
      <ProtectedE2EUserRoute>
        <SubmissionDetails />
      </ProtectedE2EUserRoute>
    } />
    <Route path="/e2e/submissions/:submissionId/edit" element={
      <ProtectedE2EUserRoute>
        <SubmissionEdit />
      </ProtectedE2EUserRoute>
    } />
    <Route path="/e2e/forms/:submissionId/clarify" element={
      <ProtectedE2EUserRoute>
        <ClarifySubmission />
      </ProtectedE2EUserRoute>
    } />

    <Route path="/e2e/reviewer" element={
      <ProtectedE2EReviewerRoute>
        <ReviewerHome />
      </ProtectedE2EReviewerRoute>
    } />
    <Route path="/e2e/reviewer/submissions" element={
      <ProtectedE2EReviewerRoute>
        <SubmissionList />
      </ProtectedE2EReviewerRoute>
    } />
    <Route path="/e2e/reviewer/submissions/view/:submissionId" element={
      <ProtectedE2EReviewerRoute>
        <ReviewerSubmissionDetails />
      </ProtectedE2EReviewerRoute>
    } />
    <Route
      path="/e2e/reviewer/submissions/:submissionId"
      element={
        <ProtectedE2EReviewerRoute>
          <SubmissionReview />
        </ProtectedE2EReviewerRoute>
      }
    />

  </Routes>
);
export default AppRoutes;